import React, { Component } from 'react';
import MainImg from '../../assets/Product/main.png'
import './Main.css';

export default class Main extends Component {
    render() {
        return (
            <div className="main-page">
                <div className="row" style={{ padding: "0px" }}>
                    {/* <img src={MainImg} alt="main" className="mainimg" /> */}
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6" style={{ padding: "0px" }}>

                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6" style={{ padding: "0px" }}>
                        <h3 className="main-head">ThreatSpy</h3>
                        <h5 className="content">Get real-time assessment reports based on threat prediction mechanism for your Web & Mobile Application.</h5>
                        <button type="button" className="btn btn-outline-white" id="butt">
                            <span className="btn-content">Book Demo</span>
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}